import request from '../until/request.js'


export function token(data) {   //获取token
    return request({
        method: 'post',
        url: `http://212.64.61.94:8095/loginNew`,
        data
    })
}

export function roteZhengCe(data) {   //热门政策(阅读热门)
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/hotASENAPolicy`,
        data
    })
}

export function xiangGuanSearch(data) {   //相关搜索
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/hot`,
        data
    })
}

export function getYearList(data) {   //获取年份----高级搜索的选择项
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/year/list`,
        data
    })
}

export function getBuMenList(data) {   //获取部门----高级搜索的选择项
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/dept/list`,
        data
    })
}

export function tupulist(data) {   //时间线，图谱
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/policyMap`,
        data
    })
}

export function allSearch(data) {   //政策全局搜索
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/list`,
        data
    })
}

export function aseanpolicyInfo(data) {   //政策详情
    return request({
        method: 'get',
        url: `rdchanping/aseanpolicy/info`,
        data
    })
}








